module.exports = "<div class='message-wrapper' ng-class='\"message-wrapper-\" + (type || \"info\")' ng-style=\"style\">\r\n    <div class=\"message-icon\" ng-class='\"message-icon-\" + (type || \"info\")'></div>\r\n    <div class=\"message-text\">{{message}}</div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/components/message.html
// module id = koE3
// module chunks = 1